import * as React from "react";
const SvgSizeCLine = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M21 20a1 1 0 1 1 0 2h-8a1 1 0 1 1 0-2zM20 2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v4h3V7.667H9V10H7V7.667a2 2 0 0 1 2-2l3-.001V4a2 2 0 0 1 2-2zM10 12H4v4h6z", clipRule: "evenodd" }));
export default SvgSizeCLine;
